import { loadPreferredLocaleBundle } from './src/loadPreferredLocaleBundle';
// eslint-disable-next-line @trello/no-module-logic
loadPreferredLocaleBundle();
